import * as React from 'react'

import { cn } from './cn'

export interface ContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false
  disableGutters?: boolean
  component?: React.ElementType
}

const maxWidthClasses = {
  xs: 'max-w-[444px]',
  sm: 'max-w-[600px]',
  md: 'max-w-[900px]',
  lg: 'max-w-[1200px]',
  xl: 'max-w-[1536px]',
}

const Container = React.forwardRef<HTMLDivElement, ContainerProps>(
  (
    {
      maxWidth = 'lg',
      disableGutters,
      component: Component = 'div',
      className,
      ...props
    },
    ref,
  ) => (
    <Component
      ref={ref}
      className={cn(
        'mx-auto w-full',
        maxWidth && maxWidthClasses[maxWidth],
        !disableGutters && 'px-4 sm:px-6',
        className,
      )}
      {...props}
    />
  ),
)
Container.displayName = 'Container'

export default Container
